import { useDispatch, useSelector } from 'react-redux';
import { AppRemixIcon } from '@/layout/AppComponents';
import * as currentPageAction from '../../../../../store/actions/currentPageAction';
import errorHandler from '../../../../components/error/ErrorHandler';

export default function BlockChangeResourceCheckbox({ resourceID }) {
  const dispatch = useDispatch();
  const checkedResourcesBlockChange = useSelector(
    (state) => state.currentPage?.checkedResourcesBlockChange,
  );

  const toggleCheckbox = async () => {
    const tempChecked = !checkedResourcesBlockChange
      ? []
      : [...checkedResourcesBlockChange];
    try {
      if (tempChecked.includes(resourceID)) {
        dispatch(
          currentPageAction.change(
            'checkedResourcesBlockChange',
            tempChecked.filter((id) => id !== resourceID),
            true,
          ),
        );
      } else {
        tempChecked.push(resourceID);
        dispatch(
          currentPageAction.change(
            'checkedResourcesBlockChange',
            tempChecked,
            true,
          ),
        );
      }
    } catch (err) {
      dispatch(errorHandler(err));
    }
  };

  return (
    <AppRemixIcon
      className="pointer"
      icon={
        checkedResourcesBlockChange &&
        checkedResourcesBlockChange.includes(resourceID)
          ? 'checkbox'
          : 'checkbox-blank'
      }
      size={20}
      onClick={() => toggleCheckbox()}
    />
  );
}
